import type { UserInviteFields } from '~/components/containers/UserManagementContainer/data/UserInvite';
import type { ErrorType } from '~/data/ErrorRecord';

export const defaultState: Fields = {
  isLoading: false,
  isModalOpen: false,
  invite: undefined,
  error: undefined,
};

export interface Fields {
  isLoading: boolean;
  isModalOpen: boolean;
  invite?: UserInviteFields;
  error?: ErrorType;
}
